import { type ModalProps } from '../types';
import styles from '../Modal@desktop.module.css';

export const getOverlayClassName = (size: ModalProps['size']) => {
    switch (size) {
        case 'fullscreen':
            return styles.Modal_overlay_size_fullscreen;

        default:
            return undefined;
    }
};
